import { useEffect, useState } from "react";

type Dimensions = {
  margins: {
    tm: number;
    lm: number;
    rm: number;
    bm: number;
  };
  sideBarWidth: number;
  drawingAreaWidth: number;
  contentHeight: number;
  screensHeight: number;
  toolbarHeight: number;
};
const useDimensions = () => {
  const calculateDimensions = (): Dimensions => {
    const Width = window.innerWidth;
    const Height = window.innerHeight;

    const BOver18 = Math.floor((Height - 200) / 18);
    const actionsHeight = 100;
    if (Width >= BOver18 * 32) {
      const whiteboardHeight = BOver18 * 18;
      const screensHeight = Height - actionsHeight - whiteboardHeight;

      const sidebarWidth = (whiteboardHeight / 9) * 4;
      const contentWidth = (whiteboardHeight / 9) * 12;

      const lm = Math.round((Width - (sidebarWidth + contentWidth)) / 2);
      const rm = Width - (sidebarWidth + contentWidth + lm);

      // console.log('A is greater');
      // const h3Holder = BOver18 * 18; // done
      // const h3 = A - 100 - h3Holder;
      // const w1 = (B / 18) * 24; // done
      // const w2 = (B / 18) * 8; // done
      // const lm = Math.ceil((A - (w1 + w2)) / 2); // done
      // const rm = A - (w1 + w2 + lm);
      // const tm = 0;
      // const bm = 0;
      // console.log('case 1 => ', {
      //     A,
      //     B,
      //     h3,
      //     w1,
      //     w2,
      //     lm,
      //     rm,
      //     tm,
      //     bm,
      //     screensHeight,
      // });
      return {
        margins: {
          tm: 0,
          lm,
          rm,
          bm: 0,
        },
        sideBarWidth: sidebarWidth,
        drawingAreaWidth: contentWidth,
        contentHeight: whiteboardHeight,
        screensHeight,
        toolbarHeight: actionsHeight,
      };
    }
    const contentWidth = Math.floor(Width / 32) * 24;
    const sidebarWidth = Math.floor(Width / 32) * 8;

    const lm = Math.ceil((Width - contentWidth - sidebarWidth) / 2);
    const rm = Width - (sidebarWidth + contentWidth + lm);

    const whiteboardHeight = ((contentWidth + sidebarWidth) / 16) * 9;

    const screensHeight = (Width * 3) / 4 - (actionsHeight + whiteboardHeight);
    const tm = Math.floor(
      (Height - actionsHeight - screensHeight - whiteboardHeight) / 2
    );
    const bm = Height - (actionsHeight + screensHeight + whiteboardHeight + tm);

    return {
      margins: {
        tm,
        lm,
        rm,
        bm,
      },
      sideBarWidth: sidebarWidth,
      drawingAreaWidth: contentWidth,
      contentHeight: whiteboardHeight,
      screensHeight,
      toolbarHeight: actionsHeight,
    };
  };

  const [dimensions, setDimensions] = useState<Dimensions>(
    calculateDimensions()
  );

  useEffect(() => {
    const calculateDimensionsCall = () => {
      setDimensions(calculateDimensions());
    };
    window.addEventListener("resize", calculateDimensionsCall);

    return () => window.removeEventListener("resize", calculateDimensionsCall);
  }, []);
  return dimensions;
};

export default useDimensions;
